import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import SaleOrderSelect from "../../components/SaleOrderSelect/SaleOrderSelect";

import OnlinePaymentAlert from "components/OnlinePaymentAlert/OnlinePaymentAlert";

import { connect } from 'react-redux';
import { fetchPaymentPlan, updateSaleOrderAtPaymentPlan } from 'reducers/paymentplan/paymentplanActions'
import { updateSaleOrderAtToPay, updateSelectedQuotaId } from 'reducers/quotastopay/quotastopayActions'
import { fetchStatusSaleOrderInProgress } from 'reducers/saleorders/saleordersActions'

import history from 'utils/History/history';

import { headersTitles } from "./PaymentPlanVariables";

import Button from "components/CustomButton/CustomButton.jsx";

import {
  SALEORDER_SIGNED_CONTRACT
} from "constants/saleOrderTypeConst"

class PaymentPlanView extends Component {

  constructor(props) {
    super(props);
    this.loadPaymentPlan = this.loadPaymentPlan.bind(this);
    this.state = {
      quota: null
    }
  }

  loadPaymentPlan(saleOrder) {
    this.props.updateSaleOrderAtPaymentPlan(saleOrder);
    this.props.fetchPaymentPlan(saleOrder.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.saleOrderInProgressStatus !== this.props.saleOrderInProgressStatus) {
      if (nextProps.saleOrderInProgressStatus.value == false) {
        this.redirecToToPayPage();
      } else {
        this.onlinePaymentAlert.showOnlinePaymentInProgressAlert();
      }
    }
  }

  redirecToToPayPage() {
    this.props.updateSaleOrderAtToPay(this.props.saleOrder);
    this.props.updateSelectedQuotaId(this.state.quota.id);
    history.push("topay");
  }

  handlePayClick(quota) {
    this.setState({ quota: quota });
    this.props.fetchStatusSaleOrderInProgress(this.props.saleOrder.id);
  }

  render() {
    return (
      <div className="main-content">
        <OnlinePaymentAlert ref={instance => { this.onlinePaymentAlert = instance; }} />
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <Col md={6}>
                      <SaleOrderSelect
                        onRef={ref => (this.saleOrderSelect = ref)}
                        loadParentContent={this.loadPaymentPlan}
                        firstItemLabel="SELECCIONAR LOTE"
                        saleOrder={this.props.saleOrder}
                        saleOrderType={SALEORDER_SIGNED_CONTRACT}
                      />
                    </Col>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          {headersTitles.map((prop, key) => {
                            return <th key={key}>{prop}</th>;
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.quotas.map((quota, key) => {
                          let color = "";
                          if (quota.status === "PAGADA") {
                            color = "success";
                          } else {
                            if (quota.overdue == true) {
                              color = "danger"
                            }
                          }
                          return (
                            <tr key={key} className={color}>
                              <td>{quota.number}</td>
                              <td>{quota.dueDate}</td>
                              <td className="text-right">{quota.amount}</td>
                              <td className="text-right">{quota.paidAmount}</td>
                              <td>{quota.paidDate != null ? quota.paidDate : "-"}</td>
                              <td className="text-right">{quota.balanceToPay}</td>
                              <td>{quota.status}</td>
                              <td>
                                {quota.status === "POR PAGAR" &&
                                  <Button bsStyle="primary"
                                    fill
                                    wd
                                    onClick={(evt) => this.handlePayClick(quota)} >
                                    Pagar
                                  </Button>
                                }
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  quotas: state.paymentplan.quotas,
  saleOrder: state.paymentplan.saleOrder,
  saleOrderInProgressStatus: state.saleorders.saleOrderInProgressStatus
});

export default connect(mapStateToProps,
  {
    fetchPaymentPlan,
    updateSaleOrderAtToPay,
    updateSaleOrderAtPaymentPlan,
    updateSelectedQuotaId,
    fetchStatusSaleOrderInProgress
  })(PaymentPlanView);


// WEBPACK FOOTER //
// ./src/views/PaymentPlan/PaymentPlanView.jsx